<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M18.9988 2C20.6557 2 21.9988 3.34315 21.9988 5V11C21.9988 12.6569 20.6557 14 18.9988 14H17.6178L14.446 20.3416C13.9678 21.2982 13.0195 21.9232 11.9622 21.9934L11.7628 22H11.4988C10.1734 22 9.0888 20.9685 9.00415 19.6644L8.99884 19.5V14H5.00058C4.80302 14 4.60595 13.9805 4.41223 13.9417C2.84558 13.6284 1.80989 12.1476 2.02926 10.5855L2.05884 10.4117L3.25884 4.41165C3.52761 3.06781 4.66958 2.0848 6.02291 2.00521L6.20058 2H18.9988ZM17.9988 12H18.9988C19.5511 12 19.9988 11.5523 19.9988 11V5C19.9988 4.44772 19.5511 4 18.9988 4H17.9988V12ZM11.4988 20H11.7628C12.0995 20 12.4105 19.8309 12.5944 19.5554L12.6572 19.4472L15.8933 12.9751C15.9453 12.8709 15.9787 12.7588 15.9921 12.6437L15.9988 12.5279V4H6.20058C5.76362 4 5.38234 4.28272 5.24983 4.68988L5.22 4.80388L4.02 10.8039C3.91169 11.3454 4.2629 11.8723 4.80446 11.9806L4.90204 11.9951L5.00058 12H8.99884C10.0532 12 10.917 12.8159 10.9934 13.8507L10.9988 14V19.5C10.9988 19.7455 11.1757 19.9496 11.409 19.9919L11.4988 20Z"
    fill="currentColor"
  />
</svg>
